import React, { FC } from "react";

import { useFavouriteProviderContext } from "../../../../reportng/shared";
import { FavouritesSettings } from "../../../../reportng/FavouritesSettings";

import { FavouritesSettingsActions } from "../FavouritesSettingsActions";
import { FavouritesSettingsHeader } from "../FavouritesSettingsHeader";
import { IFavouritesSettingsSlideProps } from "./FavouritesSettingsSlide.types";

import { useStyles } from "../FavouritesSettings.styles";

export const FavouritesSettingsSlide: FC<IFavouritesSettingsSlideProps> = (props) => {
  const { item } = props;
  const classes = useStyles();

  const {
    state: { isFavouriteChanged, savedFavouriteItem },
    actions: { deleteFavourite, updateFavourite, cancelFavouriteChanges },
  } = useFavouriteProviderContext();

  return (
    <div className={classes.root}>
      <FavouritesSettingsHeader item={savedFavouriteItem || item} />
      <div className={classes.settingsContainer}>
        <FavouritesSettings reportId={item.mark.reportId} />
      </div>
      <FavouritesSettingsActions
        onDelete={deleteFavourite}
        onSave={updateFavourite}
        onCancel={cancelFavouriteChanges}
        isChanged={isFavouriteChanged}
        savedFavouriteItem={savedFavouriteItem}
      />
    </div>
  );
};
